import ajax from "plugins/AjaxService"
import { Alert } from "types/Alert"
import { DateRange } from "types/global"
import { dateRangeToDateRangeString } from "utils"


/**
 * Recupera tutti gli ALERTS di una specifica FARM da una data di "start" ad una data di "end"
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-29255
 */
function indexByFarm(farmId: number, range?: DateRange): Promise<{ data: Alert[] }> {
	const url = `farms/${farmId}/alerts`
	const r = dateRangeToDateRangeString(range)
	const query = `start_date=${r.start}&end_date=${r.end}`
	return ajax.get(`${url}?${query}`)
}

/**
 * Recupera un ALERT di una specifica FARM
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-58655
 */
function showByFarm(farmId: number, uuid: string): Promise<{ data: Alert }> {
	return ajax.get(`farms/${farmId}/alerts/${uuid}`)
}

const api = {
	indexByFarm,
	showByFarm,
}
export default api